export const TEST_ID = 'cautionStatusBadge';
